import { useModuleBEM } from "@b2bportal/core-themes";
import { Tabs, TabsTrigger, TabsList, TabsContent } from "@tenant/ui";
import styles from "./Benchmark.module.scss";
import { useBenchmark } from "./hook";

export const Benchmark = () => {
  const [block, cn] = useModuleBEM(styles, "Benchmark");

  const { context } = useBenchmark(cn);

  return (
    !context.isLoading &&
    !context.isError && (
      <div className={block}>
        <div className={cn("header")}>
          <p className={cn("header-title")}>{context.text.title}</p>
        </div>
        <div className={cn("content")}>
          <Tabs className={cn("tabs")} defaultValue={context.defaultTab}>
            {context.tabs.length > 1 && (
              <TabsList className={cn("tabs-list")}>
                {context.tabs.map((tab) => (
                  <TabsTrigger
                    key={tab.value}
                    value={tab.value}
                    className={cn("tab-trigger")}
                  >
                    <p>{tab.label}</p>
                  </TabsTrigger>
                ))}
              </TabsList>
            )}
            {context.tabs.map((tab) => (
              <TabsContent
                key={tab.value}
                value={tab.value}
                className={cn("tab-content")}
              >
                {tab.component}
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </div>
    )
  );
};
